export const operationsData = [
    {
        id: 1,
        category: 'sale',
        title: 'Anchor Handling',
        description: 'Specialized vessels for anchor deployment, recovery, and rig moving operations in challenging offshore environments.',
        longDescription: 'We specialize in providing high-performance vessels equipped for complex anchor handling, towing, and supply operations. Our expertise in rig moving ensures that deep-sea installations are handled with precision and safety. With a fleet of specialized Anchor Handling Tug Supply (AHTS) vessels, we deliver reliability in the most demanding maritime environments.',
        image: '/images/ads-gallery-1.webp',
        gallery: ['/images/ads-gallery-1.webp', '/images/hero-v3.webp', '/images/bottom-3.webp', '/images/bottom-4.webp'],
        tags: ['Support', 'Offshore', 'Rig Move'],
        cta: 'Request Quote'
    },
    {
        id: 2,
        category: 'hire',
        title: 'Ocean Freight',
        description: 'Global logistics solutions for bulky and heavy maritime cargo, ensuring safe delivery across international waters.',
        longDescription: 'Our ocean freight services combine global reach with meticulous planning to ensure your bulky or heavy cargo reaches its destination safely and on time. We manage the entire logistics chain, from port-to-port transportation to specialized handling for oversized loads. Our commitment to excellence makes us a trusted partner for international maritime logistics.',
        image: '/images/shipping-logistics.webp',
        gallery: ['/images/shipping-logistics.webp', '/images/bottom-1.webp', '/images/bottom-2.webp', '/images/ads-gallery-2.webp'],
        tags: ['International', 'Cargo', 'Logistics'],
        cta: 'Hire This Service'
    },
    {
        id: 3,
        category: 'repair',
        title: 'Platform Supply Vessels',
        description: 'Reliable charter options for platform supply vessels (PSV) to support offshore installations and drilling rigs.',
        longDescription: 'We provide a versatile fleet of Platform Supply Vessels (PSV) designed to support offshore oil and gas platforms. Our vessels are capable of transporting a wide range of essential supplies, including fuel, water, and specialized equipment. With advanced positioning systems and experienced crews, we ensure seamless offshore logistics support.',
        image: '/images/hero-v3.webp',
        gallery: ['/images/hero-v3.webp', '/images/ads-gallery-3.webp', '/images/bottom-2.webp', '/images/bottom-3.webp'],
        tags: ['Charter', 'Supply', 'PSV'],
        cta: 'Check Availability'
    },
    {
        id: 4,
        category: 'scrap',
        title: 'Vessel for Scrap',
        description: 'Vessels available for demolition and scrapping services.',
        longDescription: 'We offer a range of vessels for scrap, providing detailed information on tonnage and material composition for buyers in the recycling industry.',
        image: '/images/ads-gallery-4.webp',
        gallery: ['/images/ads-gallery-4.webp', '/images/hero-v3.webp', '/images/bottom-1.webp'],
        tags: ['Scrap', 'Recycling', 'Metal'],
        cta: 'Contact for Scrap'
    }
];
